import { render, staticRenderFns } from "./kundeitem.vue?vue&type=template&id=3e5e211e&scoped=true&"
import script from "./kundeitem.vue?vue&type=script&lang=js&"
export * from "./kundeitem.vue?vue&type=script&lang=js&"
import style0 from "./kundeitem.vue?vue&type=style&index=0&id=3e5e211e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5e211e",
  null
  
)

export default component.exports